export default __webpack_public_path__ + "static/media/dive.67fe22f2.jpg";